import popper from 'popper.js';
import tippy, {followCursor} from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/dist/backdrop.css';
import 'tippy.js/animations/shift-away.css';

if (!tmdbUpdateBtnScriptLoaded) {
    tmdbUpdateBtnScriptLoaded = true;
    
    document.addEventListener('DOMContentLoaded', function() {
        const tmdbUpdateBtn = document.querySelector('.tmdb-update-btn');
        tippy(tmdbUpdateBtn, {
            content: "Update content automatically from TMDB",
            arrow: true,
            arrowType: 'sharp',
            animation: 'fade',
            placement: 'top',
            // followCursor: true,
            // followCursor: 'initial',
            // plugins: [followCursor],
            // placement: 'right-start',
            hideOnClick: false
        });

        if (loggedIn) {
            $(".tmdb-update-btn").click(function(){
                var icon = $(this).find('.fas');
                icon.addClass("fa-spin");
                
                tmdbUpdateBtn._tippy.setContent('Loading content from The Movie Database...');
                tmdbUpdateBtn._tippy.setProps({
                    trigger: "manual"
                });
                tmdbUpdateBtn._tippy.show();

                $.ajax({
                    type: "GET",
                    url: item.data_type ==='Title' ? "/title/" + item.id + "/tmdb_update" : "/person/" + item.id + "/tmdb_update",
                    data: {},
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function() {
                        $(".tmdb-update-btn").find('.fas').removeClass("fa-spin");

                        tmdbUpdateBtn._tippy.setContent('Done!');
                        tmdbUpdateBtn._tippy.setProps({
                            trigger: "manual"
                        });
                        tmdbUpdateBtn._tippy.show();

                        setTimeout(function() {
                            tmdbUpdateBtn._tippy.hide(0);
                            tmdbUpdateBtn._tippy.setProps({
                                trigger: "mouseenter"
                            });
                            tmdbUpdateBtn._tippy.setContent('Update content automatically from TMDB');
                            window.location = item.id;
                        }, 3000);
                    },
                    error: function() {
                        $(".tmdb-update-btn").find('.fas').removeClass("fa-spin");

                        tmdbUpdateBtn._tippy.setContent('An error occurred. Please try again later');
                        tmdbUpdateBtn._tippy.setProps({
                            trigger: "manual"
                        });
                        tmdbUpdateBtn._tippy.show();

                        setTimeout(function() {
                            tmdbUpdateBtn._tippy.hide(0);
                            tmdbUpdateBtn._tippy.setProps({
                                trigger: "mouseenter"
                            });
                            tmdbUpdateBtn._tippy.setContent('Update content automatically from TMDB');
                        }, 3000);
                    }
                });
            });
        } else {
            //do nothing
        }
    })
}